import { updateProfile } from '../containers/ProfileSettingsPage/ProfileSettingsPage.duck';

// ================ Action types ================ //

export const ADD_PENDING_FAVORITE = 'app/pendingActions/ADD_PENDING_FAVORITE';
export const REMOVE_PENDING_FAVORITE = 'app/pendingActions/REMOVE_PENDING_FAVORITE';
export const CLEAR_PENDING_FAVORITES = 'app/pendingActions/CLEAR_PENDING_FAVORITES';
export const PROCESS_PENDING_FAVORITES_REQUEST = 'app/pendingActions/PROCESS_PENDING_FAVORITES_REQUEST';
export const PROCESS_PENDING_FAVORITES_SUCCESS = 'app/pendingActions/PROCESS_PENDING_FAVORITES_SUCCESS';
export const PROCESS_PENDING_FAVORITES_ERROR = 'app/pendingActions/PROCESS_PENDING_FAVORITES_ERROR';

// ================ Reducer ================ //

const initialState = {
    pendingFavorites: [], // Array of listing IDs that user tried to favorite before login
    processingPendingFavorites: false,
    processingError: null,
};

export default function reducer(state = initialState, action = {}) {
    const { type, payload } = action;
    switch (type) {
        case ADD_PENDING_FAVORITE:
            return {
                ...state,
                pendingFavorites: state.pendingFavorites.includes(payload.listingId)
                    ? state.pendingFavorites
                    : [...state.pendingFavorites, payload.listingId],
            };

        case REMOVE_PENDING_FAVORITE:
            return {
                ...state,
                pendingFavorites: state.pendingFavorites.filter(id => id !== payload.listingId),
            };

        case CLEAR_PENDING_FAVORITES:
            return {
                ...state,
                pendingFavorites: [],
                processingError: null,
            };

        case PROCESS_PENDING_FAVORITES_REQUEST:
            return {
                ...state,
                processingPendingFavorites: true,
                processingError: null,
            };

        case PROCESS_PENDING_FAVORITES_SUCCESS:
            return {
                ...state,
                pendingFavorites: [],
                processingPendingFavorites: false,
            };

        case PROCESS_PENDING_FAVORITES_ERROR:
            return {
                ...state,
                processingPendingFavorites: false,
                processingError: payload,
            };

        default:
            return state;
    }
}

// ================ Action creators ================ //

export const addPendingFavorite = listingId => ({
    type: ADD_PENDING_FAVORITE,
    payload: { listingId },
});

export const removePendingFavorite = listingId => ({
    type: REMOVE_PENDING_FAVORITE,
    payload: { listingId },
});

export const clearPendingFavorites = () => ({
    type: CLEAR_PENDING_FAVORITES,
});

export const processPendingFavoritesRequest = () => ({
    type: PROCESS_PENDING_FAVORITES_REQUEST,
});

export const processPendingFavoritesSuccess = () => ({
    type: PROCESS_PENDING_FAVORITES_SUCCESS,
});

export const processPendingFavoritesError = error => ({
    type: PROCESS_PENDING_FAVORITES_ERROR,
    payload: error,
    error: true,
});

// ================ Thunks ================ //

export const processPendingFavorites = () => (dispatch, getState, sdk) => {
    const state = getState();
    const { pendingFavorites } = state.pendingActions;
    const { currentUser } = state.user;

    if (!currentUser || pendingFavorites.length === 0) {
        return Promise.resolve();
    }

    dispatch(processPendingFavoritesRequest());

    // Get current favorites from user profile
    const currentFavorites = currentUser.attributes.profile?.publicData?.favorites || [];

    // Merge pending favorites with existing ones (avoid duplicates)
    const updatedFavorites = [...new Set([...currentFavorites, ...pendingFavorites])];

    // Update user profile with new favorites
    const profileData = {
        publicData: {
            ...currentUser.attributes.profile?.publicData,
            favorites: updatedFavorites,
        },
    };

    return dispatch(updateProfile(profileData))
        .then(() => {
            dispatch(processPendingFavoritesSuccess());
        })
        .catch(error => {
            dispatch(processPendingFavoritesError(error));
            throw error;
        });
};